import React from 'react'

export default function withRef(Component) {
  return React.forwardRef((props, ref) =>
    <Component ref={ref} {...props} />
  )
}



// WEBPACK FOOTER //
// ./src/lib/withRef.js